import { Button, ButtonProps } from '@chakra-ui/react';
import React, { RefAttributes, useContext } from 'react';

import UserToolTenantContext from '@/userTool/contexts/UserToolTenantContext';

type CustomButtonProps = ButtonProps & RefAttributes<HTMLButtonElement>;

const CustomButton: React.VFC<CustomButtonProps> = function CustomButton({ children, ...props }) {
  const { themeColor } = useContext(UserToolTenantContext);

  return (
    <Button {...props} colorScheme={themeColor}>
      {children}
    </Button>
  );
};

export default CustomButton;
